import { render, staticRenderFns } from "./SecaoBanner.vue?vue&type=template&id=67d096d8&"
import script from "./SecaoBanner.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoBanner.vue?vue&type=script&async=true&lang=js&"
import style0 from "./SecaoBanner.vue?vue&type=style&index=0&id=67d096d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports